import { getRouteApi, Link, Navigate } from "@tanstack/react-router";
import {
    ContactLinkExpired,
    contactLinkHead,
    PRIVATE_LINK_HEADERS,
} from "./contact-link-shell";
import { loadContactLinkPreview } from "./contact-link-preview";

const routeApi = getRouteApi("/k/$token");

export const providerOutreachLinkRoute = {
    loader: ({ params }: { params: { token: string } }) =>
        loadContactLinkPreview(params.token),
    head: ({
        loaderData,
    }: {
        loaderData?: Awaited<ReturnType<typeof loadContactLinkPreview>>;
    }) => contactLinkHead(loaderData),
    headers: () => PRIVATE_LINK_HEADERS,
};

export function ContactLinkRoute() {
    const result = routeApi.useLoaderData();
    if (!result) return <ContactLinkExpired kind="k" />;
    return (
        <main className="flex min-h-dvh items-center justify-center bg-maltese-white p-6 text-brown">
            <Navigate
                to="/dog/$dogId"
                params={{ dogId: result.listingId }}
                replace
            />
            <Link
                to="/dog/$dogId"
                params={{ dogId: result.listingId }}
                replace
                className="inline-flex min-h-11 items-center text-body font-semibold underline underline-offset-4"
            >
                See {result.linkPreview.title || "this dog"} on Wags
            </Link>
        </main>
    );
}
